export const VoucherOrderHistoryDateFormat = 'DD.MM.YYYY';
export const TransactionsHistoryDateFormat = 'DD.MM.YYYY';
export const datePickerDefaultFormat = 'DD.MM.YYYY';
export const defaultDateFormat = 'dd.MM.yyyy';
export const apiDateFormat = 'yyyy-MM-dd';
export const datePickerApiFormat = 'yyyy-MM-DD';
